;(function() {
/* @ngInject */
function RozsirenieZivnostiObjednaneController(CompletedOrderService, $window, $filter, Helpers, SigniService){
  let vm = this;
  let server = CompletedOrderService;

  vm.generateDocs = generateDocs;
  vm.generateForeignerDocs = generateForeignerDocs;
  vm.getFileName = Helpers.getFileName;
  vm.payment = "movement";
  vm.showMovement = false;
  vm.isUnzipFiles = true;
  vm.showLoading = false;
  vm.showProforma = false;
  vm.hideDownloadDocuments = true;
  vm.downloadLabel = $filter("translate")('payments.documents.zivnost.rozsir');

  server.getCompletedOrderData().then(onPaymentInfoLoad);

  SigniService.handleSigniResponse();

  let dataLayerStorage = $window.localStorage.getItem('dataLayer');
  $window.localStorage.removeItem('dataLayer');
  var dataLayer = $window.dataLayer = $window.dataLayer || [];
  if (dataLayerStorage)
    dataLayer.push(JSON.parse(dataLayerStorage));

  function onPaymentInfoLoad(payment) {
    if(payment) {
      //console.log(payment);
      vm.orderId = payment.orderId;
      vm.price = payment.price;
      vm.hideDownloadDocuments = payment.hideDownloadDocuments;
      vm.paymentData = payment;
      vm.invoiceHref = `/invoice/download?orderId=${payment.orderId}`;
      vm.proformaHref = `/invoice/download?proforma=true&orderId=${payment.orderId}`;
      vm.documentsHref = `/objednavka/detail?o=${payment.documentsLink}`;
      vm.documentsForeignerHref = `/objednavka-cudzinci/detail?o=${payment.documentsLink}`;
    } else {
      $window.location = "krok1";
    }
  }

  function generateDocs() {
    vm.showLoading = true;
    server.regenerateDocs().then(() => {
      server.getCompletedOrderData().then((p) => {
        if(p.documentsLink) {
          let url = '/objednavka/detail?o=' + p.documentsLink;
          $window.location = url;
        }
      });
      vm.showLoading = false;
    });
  }

  function generateForeignerDocs() {
    vm.showLoading = true;
    server.regenerateForeignerDocs().then(() => {
      server.getCompletedOrderData().then((p) => {
        if(p.documentsLink) {
          let url = '/objednavka-cudzinci/detail?o=' + p.documentsLink;
          $window.location = url;
        }
      });
      vm.showLoading = false;
    });
  }
}

angular.module("firmaren")
  .controller("RozsirenieZivnostiObjednaneController", RozsirenieZivnostiObjednaneController);
}());
